import ClientConfig from './client.config';
import ClientRegistrationUsersController from './client-registration.users.controller';
import ClientRegistrationContinueUsersController from './client-registration-continue.users.controller';
import ClientActivationConfirmUsersController from './client-activation-confirm.users.controller';
import ClientActivationRetryUsersController from './client-activation-retry.users.controller';
import ClientLoginUsersController from './client-login.users.controller';
import ShareResourceUsersController from './shareResource.users.controller';
import ClientSharedResourceUsersController from './client-shared-resources.users.controller'
import ClientRegistrationConfirmUsersController from './client-registration-confirm.users.controller'
import ClientActivationUsersController from './client-activation.users.controller'

let clientModule = angular.module('ff.users.client', []);

clientModule.config(ClientConfig);
clientModule.controller('ClientRegistrationUsersController', ClientRegistrationUsersController);
clientModule.controller('ClientRegistrationContinueUsersController', ClientRegistrationContinueUsersController);
clientModule.controller('ClientActivationConfirmUsersController', ClientActivationConfirmUsersController);
clientModule.controller('ClientActivationRetryUsersController', ClientActivationRetryUsersController);
clientModule.controller('ClientLoginUsersController', ClientLoginUsersController);
clientModule.controller('ShareResourceUsersController', ShareResourceUsersController);
clientModule.controller('ClientSharedResourceUsersController', ClientSharedResourceUsersController);
clientModule.controller('ClientRegistrationConfirmUsersController', ClientRegistrationConfirmUsersController);
clientModule.controller('ClientActivationUsersController', ClientActivationUsersController);

export default clientModule = clientModule.name



// WEBPACK FOOTER //
// ./src/users/client/client.module.js